/**
 * SG-002: after a document is saved, stay on the document that was just saved
 * instead of bouncing back to the list, so the user can verify it before
 * sending it for approval without having to remember the document code.
 *
 * Falls back to the list path when the response carries no id, so a create
 * that returns nothing does not strand the user on a blank detail page.
 */
export const getDocumentDetailPath = (
  listPath: string,
  documentId?: number | string | null
): string => {
  const base = listPath.replace(/\/+$/, '')
  const id = Number(documentId) || 0

  return id > 0 ? `${base}/${id}/detail` : base
}
